var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"privat-layout"}},[(_vm.abilitiesLoaded)?_c('router-view'):_vm._e(),_c('new-app-version-modal',{ref:"newAppVersionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }